import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export interface Statistic {
  keys: string[];
  headers: string[][];
  values: any[][];
}

export function useGetStatisticsQuery<D extends Statistic[]>(params?: HydraQueryParams<D>) {
  const { vars, options, key, httpHeaders } = params || {};
  return useHydraQuery<D>('statistics', '/api/statistics', {
    vars,
    options,
    key,
    httpHeaders,
  });
}
